module.exports = __webpack_public_path__ + "static/media/IconWarningRed.516ae320.svg";